import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { Img } from '@shared/Frontend/components/img'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { SVGIcon } from '@shared/Frontend/utils/svg'

export const QuoteBlock: BlocksView['QuoteBlock'] = (props) => {
  const { id, image } = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section
      id={id}
      ref={ref}
      className={cn(`block block--quote quote--${image ? 'image' : 'text'} ls-spacing`, inView && 'inview')}
    >
      <div className="block__inner ls-container ls-gutter">
        <div className="block__layout">
          {image && (
            <div className="block__visual fit-object">
              <Img {...image} loading="lazy" className="block__image" width="176" height="176" sizes='176px' />
            </div>
          )}

          <div className="block__content">
            <QuoteLayout {...props} />
            <BlockActions {...props} datalayerCategory="quote_block" />
          </div>
        </div>
      </div>
    </section>
  )
}
export const QuoteLayout = (props: { text: string; author?: string; authorDescription?: string }) => {
  const { text, author, authorDescription } = props
  return (
    <>
      <blockquote className="quote">
        <div className="quote__text title--sm" dangerouslySetInnerHTML={{ __html: text }} />
        <SVGIcon className="quote__blob" id="icon-blob" width={72} height={60} />
        <SVGIcon className="quote__marks" id="icon-quotes" width={32} height={23} />
      </blockquote>

      {(author || authorDescription) && (
        <figcaption className="quote__caption text--sm">
          {author && <span className="quote__author">&mdash; {author}</span>}
          {authorDescription && <span className="quote__description">{`, ${authorDescription}`}</span>}
        </figcaption>
      )}
    </>
  )
}
